var QrScanner = require('../../src/js/client/components/QrScanner').default;

exports._qrScanner = QrScanner;
